import React from 'react'

export default function Page2() {
  return (
    <div id='page2'>
        <div id='scroller'>
            <div className="scroller-in">
                <h4>WAM</h4>
                <h4>FLOW</h4>
                <h4>DESIGN</h4>
                <h4>IDEAS</h4>
            </div>
            <div className="scroller-in">
                <h4>WAM</h4>
                <h4>FLOW</h4>
                <h4>DESIGN</h4>
                <h4>IDEAS</h4>
            </div>
        </div>
        </div>
  )
}
